import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { invalidateTimesheetQuery } from './query';
export const useInvalidateTimesheet = () => {
    const client = useQueryClient();
    return useCallback((id) => invalidateTimesheetQuery(client, id), [client]);
};
//# sourceMappingURL=use-query.js.map